import {
  PARAMETER_ROWS,
  PARAMETER_COLUMNS,
  RENDER_BIKES,
  REFERENCE_POINTS,
  PARAMETER_LENGTH,
  PARAMETER_DIMENSIONS,
  PARAMETER_WIDTH,
  PARAMETER_BIKE_COUNT,
  PARAMETER_CONFIGURATION,
  PARAMETER_RACK,
  SAVE_PDF_OFF,
  SAVE_PDF_ON,
  SWITCH_UX_PATH,
  CONFIGURATION_RESULTS,
  UNDO_WIDTH,
  UNDO_LENGTH
} from '../config/constants';
import * as THREE from 'three';
import { stat } from 'fs';
const initialState = {
  rows: 1,
  columns: 1,
  uxPath: 'bikes',
  positions: [new THREE.Vector3(0, 0, 0)],
  renderBikes: true,
  pastWidth: [],
  pastLength: [],
  width: 20,
  length: 30,
  count: 20,
  configuration: 'Max Density',
  rack: 'hybrid',
  savePdf: false,
  bikeConfiguration: {},
  marginAdds: {}
};

const demo = (state = initialState, action) => {
  const { data } = action;
  switch (action.type) {
    case CONFIGURATION_RESULTS:
      return { ...state, ...data };
    case SWITCH_UX_PATH:
      return { ...state, uxPath: data };
    case SAVE_PDF_OFF:
      return { ...state, savePdf: false };
    case SAVE_PDF_ON:
      return { ...state, savePdf: true };
    case PARAMETER_ROWS:
      return { ...state, rows: data };
    case PARAMETER_CONFIGURATION:
      return { ...state, configuration: data };
    case PARAMETER_RACK:
      return { ...state, rack: data };
    case PARAMETER_COLUMNS:
      return { ...state, columns: data };
    case PARAMETER_LENGTH:
      return {
        ...state,
        length: data,
        uxPath: 'dimensions',
        pastLength: [...state.pastLength, state.length].filter((el) => el)
      };
    case PARAMETER_DIMENSIONS:
      return {
        ...state,
        ...data,
        uxPath: 'dimensions',
        pastLength: [],
        pastWidth: []
      };
    case PARAMETER_WIDTH:
      return {
        ...state,
        width: data,
        uxPath: 'dimensions',
        pastWidth: [...state.pastWidth, state.width].filter((el) => el)
      };
    case UNDO_WIDTH:
      const newWidth = [...state.pastWidth];
      const widthValue = newWidth.pop();
      return {
        ...state,
        width: widthValue,
        uxPath: 'dimensions',
        pastWidth: newWidth
      };
    case UNDO_LENGTH:
      const newLength = [...state.pastLength];
      const lengthValue = newLength.pop();
      return {
        ...state,
        length: lengthValue,
        uxPath: 'dimensions',
        pastLength: newLength
      };
    case PARAMETER_BIKE_COUNT:
      return { ...state, count: data, uxPath: 'bikes' };
    case RENDER_BIKES:
      return { ...state, renderBikes: data };
    case REFERENCE_POINTS:
      return { ...state, positions: data };
    default:
      return state;
  }
};

export default demo;



// WEBPACK FOOTER //
// ./src/reducers/parameters.js